import { Authentication, useConnections } from "@zapier/client";
import { Badge, Paginator, Text } from "@zapier/design-system";
import styles from "./AppDetails.module.css";
import { useState } from "react";
import { CONNECTIONS_PAGE_SIZE, getServiceIconUrl } from "@zapier/utils";
import ConnectionsTable from "../connections/ConnectionsTable/ConnectionsTable";
import { ConnectionModal } from "../connections/types";
import { AppDetailsEmpty } from "./AppDetailsEmpty";
import { useTranslations } from "@zapier/i18n";
interface Props {
  title: string;
  type: "personal" | "shared" | "private";
  serviceSlug?: string;
  selectedApi?: string;
  currentConnection: Authentication | undefined;
  currentConnectionModal: ConnectionModal | undefined;
  setCurrentConnection: (connection: Authentication | undefined) => void;
  setCurrentConnectionModal: (modal?: ConnectionModal | undefined) => void;
}

export function AppDetailsConnections({
  title,
  type,
  serviceSlug,
  selectedApi,
  currentConnection,
  currentConnectionModal,
  setCurrentConnection,
  setCurrentConnectionModal,
}: Props) {
  const t = useTranslations("app-details");
  const [page, setPage] = useState(1);

  const { connections, totalCount, isLoading, isLoadingSecondary } =
    useConnections({
      includeCompatible: true,
      owner: type === "personal" ? "me" : type === "shared" ? "!me" : undefined,
      shared: type === "shared" ? true : type === "private" ? false : undefined,
      selectedApi,
      serviceSlug,
      page,
    });

  const totalPages = Math.ceil(totalCount / CONNECTIONS_PAGE_SIZE);

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <Text tag="h2" type="SectionHeader">
          {title}
        </Text>
        <Badge variant="primary">{String(totalCount)}</Badge>
        {type === "private" && (
          <Badge variant="neutral">{t("table.admins-only")}</Badge>
        )}
      </div>

      {totalCount === 0 && <AppDetailsEmpty type={type} />}
      {totalCount > 0 && (
        <ConnectionsTable
          allowsSorting={false}
          ariaLabel="App details connections"
          connections={connections}
          totalCount={totalCount}
          isLoading={isLoading}
          isLoadingSecondary={isLoadingSecondary}
          onAddConnection={() => {}}
          onAddManagedConnection={() => {}}
          currentConnection={currentConnection}
          currentConnectionModal={currentConnectionModal}
          setCurrentConnection={setCurrentConnection}
          setCurrentConnectionModal={setCurrentConnectionModal}
          connectionIconOverride={getServiceIconUrl(serviceSlug)}
          withModals={false}
        />
      )}

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <Paginator
            condenseAt={8}
            currentPageIndex={page - 1}
            pageUrls={Array.from({ length: totalPages }).map(() => "")}
            isCentered={true}
            onPaginate={({ pageIndex }) => setPage(pageIndex + 1)}
          />
        </div>
      )}
    </div>
  );
}
